export { default } from './ClModal.vue';
export { ClModalProps } from './ClModal.types';
